import { strField } from '@/shared/api/fieldCase';

import type { CustomerRow } from '../types';

function asRecord(v: unknown): Record<string, unknown> | null {
  if (v && typeof v === 'object' && !Array.isArray(v)) return v as Record<string, unknown>;
  return null;
}

export function mapRemoteCustomer(raw: unknown): CustomerRow | null {
  const o = asRecord(raw);
  if (!o) return null;
  const id = strField(o, 'id', 'id');
  if (!id) return null;
  const referral = strField(o, 'referralCode', 'referral_code');
  return {
    id,
    authId: strField(o, 'authId', 'auth_id'),
    // Do not synthesize references on the frontend. Show only what the backend sends.
    displayId: referral,
    fullName: strField(o, 'fullName', 'full_name'),
    phoneNumber: strField(o, 'phoneNumber', 'phone_number'),
    email: strField(o, 'email', 'email'),
    gender: strField(o, 'gender', 'gender'),
    profilePicture: strField(o, 'profilePicture', 'profile_picture'),
    status: strField(o, 'status', 'status'),
    referralCode: referral,
    createdAt: strField(o, 'createdAt', 'created_at'),
    updatedAt: strField(o, 'updatedAt', 'updated_at'),
  };
}
